import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function generateQuotePdf(client, brandName = "Groupfie Studio") {
  const doc = new jsPDF();
  const primaryColor = [20, 39, 81]; // #142751 (Blue)

  // 1. Header & Title
  doc.setFillColor(...primaryColor);
  doc.rect(0, 0, 210, 28, "F");

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text(`${brandName.toUpperCase()} — QUOTATION & ESTIMATE`, 14, 18);

  // 2. Client & Quote Info
  doc.setTextColor(50, 50, 50);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  const today = new Date().toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  doc.text(`Client Name: ${client.name || "N/A"}`, 14, 38);
  doc.text(`Contact Email: ${client.contact_email || "N/A"}`, 14, 44);
  doc.text(`Contact Phone: ${client.contact_phone || "N/A"}`, 14, 50);

  doc.text(`Quote Date: ${today}`, 135, 38);
  doc.text(
    `Expected Delivery Target: ${
      client.expected_delivery_date
        ? new Date(client.expected_delivery_date).toLocaleDateString()
        : "N/A"
    }`,
    135,
    44
  );

  // Divider Line
  doc.setDrawColor(220, 220, 220);
  doc.line(14, 56, 196, 56);

  // 3. Events & Crew Requirements Table
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Scheduled Events & Requirements", 14, 65);

  const eventRows = (client.events || []).map((ev, index) => [
    `Event ${index + 1}: ${ev.event_name || "N/A"}`,
    ev.event_date ? new Date(ev.event_date).toLocaleDateString() : "TBD",
    `${ev.needed_photographers || 0} Photographers`,
    `${ev.needed_videographers || 0} Videographers`,
    (ev.addons || []).join(", ") || "None",
  ]);

  autoTable(doc, {
    startY: 70,
    head: [["Event Name", "Date", "Photographers", "Videographers", "Addons"]],
    body: eventRows,
    headStyles: { fillStyle: "F", fillColor: primaryColor, textColor: 255 },
    styles: { fontSize: 9 },
  });

  let lastY = doc.lastAutoTable.finalY + 12;

  // 4. Package & Deliverables
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Package Deliverables & Summary", 14, lastY);

  const deliverables = (client.package?.addons || []).join(", ") || "Standard Package";

  const packageRows = [
    ["Album Type", `${client.package?.album_type || "Lustre"}`],
    ["Album Pages", `${client.package?.album_pages || 0 } Pages`],
    ["Deliverables", deliverables],
    [
      "Total Estimated Amount",
      `Rs ${(client.package?.total_committed_amount || 0).toLocaleString()}`,
    ],
  ];

  autoTable(doc, {
    startY: lastY + 5,
    body: packageRows,
    theme: "plain",
    styles: { fontSize: 10, cellPadding: 3 },
    columnStyles: {
      0: { fontStyle: "bold", cellWidth: 50 },
      1: { cellWidth: 130 },
    },
  });

  lastY = doc.lastAutoTable.finalY + 12;

  // 5. Terms & Payment Schedule
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(37, 99, 235); // Blue Accent
  doc.text("Terms & Payment Schedule", 14, lastY);

  doc.setTextColor(50, 50, 50);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);

  // Travel Note
  lastY += 5;
  doc.text("• Travel Expenses: Charged extra for locations beyond 25 km from the studio.", 14, lastY);

  // Installments Schedule Table
  const paymentScheduleRows = [
    ["First Installment", "10%", "At the time of booking confirmation"],
    ["Second Installment", "30%", "After the first event (70% for single-event projects)"],
    ["Third Installment", "40%", "After the second event"],
    ["Final Settlement", "Remaining", "After delivering all final deliverables"],
  ];

  autoTable(doc, {
    startY: lastY + 3,
    head: [["Installment", "Share", "Payment Terms & Timeline"]],
    body: paymentScheduleRows,
    theme: "grid",
    headStyles: { fillStyle: "F", fillColor: [240, 240, 240], textColor: 50, fontStyle: "bold" },
    styles: { fontSize: 8, cellPadding: 2.5 },
    columnStyles: {
      0: { cellWidth: 38, fontStyle: "bold" },
      1: { cellWidth: 22 },
      2: { cellWidth: 122 },
    },
  });

  lastY = doc.lastAutoTable.finalY + 10;

  // 6. Footer Notes
  doc.setFontSize(8);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(120, 120, 120);
  doc.text(
    `Thank you for considering our ${brandName} services! This document serves as an official quote estimate.`,
    14,
    lastY
  );
  doc.text(
    "Delivery dates are subject to change based on project requirements and availability. Please review the details and contact us for any clarifications.",
    14,
    lastY + 4
  );

  // Save the PDF
  const sanitizedFilename = (client.name || "client")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "_");
  doc.save(`${brandName.replace(/\s+/g, "_")}_Quote_${sanitizedFilename}.pdf`);
}